import Tastet from '../tastet.js';
import Template from '../modules/template.js';

const CLASSES = {
  IS_HIDDEN: 'form--hidden',
};

export default class Form extends Tastet.View {
  // init ------------------------------------------------------------------------------------------------------------
  init($el, data) {
    data = this.set(data || {}, {
      method: ($el.attr('method') || 'ajax').toLowerCase(),
      nextSelector: '[data-action="next_question"]',
      questionSelector: '.question',
      validate: null,
    });

    data.url = $el.attr('action');

    this.$notification = this.$notification || this.$();
    this.notification = new Template(this.$notification);

    this.$form = this.$element.find(true, 'form');
    this.$next = data.nextSelector ? this.$element.find(data.nextSelector) : this.$();
    this.$question = data.questionSelector ? this.$element.find(data.questionSelector) : this.$();
  }

  addEvents() {
    this.on(this.$element, 'submit', this.form_onSubmit);

    this.$next.on('click', this.next_onClick);
  }

  render() {}

  // private ---------------------------------------------------------------------------------------------------------
  _send(values, isPartial, isLast) {
    var data = this.get();
    values = values || this.values();

    var valid = this.isValid(values);
    if (valid !== true) {
      this.notification.render(valid || {}, 'message/invalid');
      return;
    }

    if (data.method === 'ajax') {
      this.isLoading(true);
      this.http(data.url, { values: values }, function (response, success) {
        this.isLoading(false);

        response = response || {};

        if (this.utils.is.obj(response)) {
          response.is_partial = isPartial; // partial question values was sent
          response.is_last = isLast; // last question
        }

        this.$form.addClass('submitted');
        this.notification.render(response, 'message/' + response.status);
      });
    } else if (data.method === 'none') {
      // nothing
      this.trigger('sent', { values: values });
    } else {
      this.$form.get().submit();
    }
  }

  // events ----------------------------------------------------------------------------------------------------------
  form_onSubmit(e) {
    e.preventDefault();
    this.notification.clear();
    this._send();
  }

  next_onClick(e) {
    e.preventDefault();

    var isSubmit = e.target.getAttribute('type') === 'submit';

    var $current = null;
    var isLast = false;
    this.$question.each(true, ($el, i, a) => {
      if ($el.contains(e.target)) {
        // Save the current block
        $current = $el;

        // update the visible question
        // if the triggered NEXT button is in the current question, show the next one
        if (a.next) {
          $el.addClass(CLASSES.IS_HIDDEN);
          this.utils.dom.classnames.remove(a.next, CLASSES.IS_HIDDEN);
        } else {
          isLast = true;
        }
      }
    });

    // If the button was supposed to submit, get the current values of question
    if (isSubmit && $current) {
      var values = this.utils.dom.values($current) || {};
      this._send(values, true, isLast);
    }
  }

  // methods ---------------------------------------------------------------------------------------------------------
  isLoading(value) {
    super.isLoading(value, 'loader');
  }

  isValid(values) {
    var data = this.get();
    var values = values || this.values();

    // Quick validation
    if (data.validate) {
      return this.apply(data.validate, [values]);
    }

    return true;
  }

  values(v) {
    if (v) {
      this.utils.dom.values(this.$element, values);
      return this;
    } else {
      var values = this.utils.dom.values(this.$element) || {};
      return values;
    }
  }

  notify(data, type) {
    this.notification.render(data || {}, 'message/' + type);
  }
}
